import { render, staticRenderFns } from "./addPromotion.vue?vue&type=template&id=e21dcbf0&scoped=true"
import script from "./addPromotion.vue?vue&type=script&lang=js"
export * from "./addPromotion.vue?vue&type=script&lang=js"
import style0 from "./addPromotion.vue?vue&type=style&index=0&id=e21dcbf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21dcbf0",
  null
  
)

export default component.exports